"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = exports.isSound = exports.isCategory = void 0;
var utils_1 = require("./utils");
var isCategory = function (value) {
    return typeof value === 'object' && value && 'guildId' in value;
};
exports.isCategory = isCategory;
var isSound = function (value) {
    return typeof value === 'object' && value && 'hash' in value;
};
exports.isSound = isSound;
exports.api = {
    _fetch: function (url_1) {
        return __awaiter(this, arguments, void 0, function (url, method, data) {
            var resp, errorMsg;
            if (method === void 0) { method = 'GET'; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(url, {
                            method: method,
                            body: data instanceof ArrayBuffer ? data : JSON.stringify(data),
                        })];
                    case 1:
                        resp = _a.sent();
                        if (!!resp.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        errorMsg = (_a.sent()).error;
                        (0, utils_1.error)(errorMsg);
                        (0, utils_1.handleNotAuthenticatedError)(errorMsg);
                        throw new Error(errorMsg);
                    case 3: return [2 /*return*/, resp.json()];
                }
            });
        });
    },
    me: function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)('Fetch current user');
                        return [4 /*yield*/, exports.api._fetch('/api/me')];
                    case 1:
                        user = (_a.sent()).user;
                        return [2 /*return*/, user];
                }
            });
        });
    },
    listGuilds: function () {
        return __awaiter(this, void 0, void 0, function () {
            var guilds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)('Fetch user guild list');
                        return [4 /*yield*/, exports.api._fetch('/api/list_user_guilds')];
                    case 1:
                        guilds = (_a.sent()).guilds;
                        return [2 /*return*/, guilds];
                }
            });
        });
    },
    listCategoriesAndSounds: function (guildId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, categories, sounds;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (0, utils_1.log)("Fetch categories and sounds for guild ".concat(guildId));
                        return [4 /*yield*/, exports.api._fetch('/api/list_guild_categories_and_sounds?guild=' + guildId)];
                    case 1:
                        _a = _b.sent(), categories = _a.categories, sounds = _a.sounds;
                        return [2 /*return*/, [categories, sounds]];
                }
            });
        });
    },
    uploadSound: function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var hash;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Upload new sound");
                        return [4 /*yield*/, exports.api._fetch('/api/upload_sound', 'POST', data)];
                    case 1:
                        hash = (_a.sent()).hash;
                        return [2 /*return*/, hash];
                }
            });
        });
    },
    saveCategory: function (category) {
        return __awaiter(this, void 0, void 0, function () {
            var output;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (0, utils_1.log)("Save category ".concat(category.name, " (").concat((_a = category.id) !== null && _a !== void 0 ? _a : '(new)', ")"));
                        return [4 /*yield*/, exports.api._fetch('/api/category', category.id ? 'PUT' : 'POST', category)];
                    case 1:
                        output = (_b.sent()).category;
                        return [2 /*return*/, output];
                }
            });
        });
    },
    sortCategories: function (categories) {
        return __awaiter(this, void 0, void 0, function () {
            var guildId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (categories.length == 0)
                            return [2 /*return*/];
                        guildId = categories[0].guildId;
                        (0, utils_1.log)("Sort categories for guild ".concat(guildId));
                        return [4 /*yield*/, exports.api._fetch('/api/sort_guild_categories', 'POST', {
                                guildId: guildId,
                                ids: categories.map(function (category) { return category.id; }),
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    deleteCategory: function (category) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Delete category ".concat(category.name, " (").concat(category.id, ")"));
                        return [4 /*yield*/, exports.api._fetch('/api/category', 'DELETE', { id: category.id })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    saveSound: function (sound) {
        return __awaiter(this, void 0, void 0, function () {
            var output;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Save sound ".concat(sound.name, " with hash ").concat(sound.hash));
                        return [4 /*yield*/, exports.api._fetch('/api/sound', sound.id ? 'PUT' : 'POST', sound)];
                    case 1:
                        output = (_a.sent()).sound;
                        return [2 /*return*/, output];
                }
            });
        });
    },
    sortSounds: function (sounds) {
        return __awaiter(this, void 0, void 0, function () {
            var categoryId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (sounds.length == 0)
                            return [2 /*return*/];
                        categoryId = sounds[0].categoryId;
                        (0, utils_1.log)("Sort sounds for category ".concat(categoryId));
                        return [4 /*yield*/, exports.api._fetch('/api/sort_category_sounds', 'POST', {
                                categoryId: categoryId,
                                ids: sounds.flatMap(function (sound) {
                                    return sound.categoryId === categoryId ? [sound.id] : [];
                                }),
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    deleteSound: function (sound) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Delete sound ".concat(sound.name, " (").concat(sound.id, ")"));
                        return [4 /*yield*/, exports.api._fetch('/api/sound', 'DELETE', { id: sound.id })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    playSound: function (sound) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Play sound ".concat(sound.name, " (").concat(sound.id, ")"));
                        return [4 /*yield*/, exports.api._fetch('/api/play_sound', 'POST', { id: sound.id })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    downloadSound: function (sound) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, errorMsg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Download sound ".concat(sound.name, " (").concat(sound.id, ")"));
                        return [4 /*yield*/, fetch('/api/download_sound', {
                                method: 'POST',
                                body: JSON.stringify({ id: sound.id }),
                            })];
                    case 1:
                        resp = _a.sent();
                        if (!!resp.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        errorMsg = (_a.sent()).error;
                        (0, utils_1.error)(errorMsg);
                        (0, utils_1.handleNotAuthenticatedError)(errorMsg);
                        throw new Error(errorMsg);
                    case 3: return [4 /*yield*/, resp.arrayBuffer()];
                    case 4: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    stopSounds: function (guildId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Stop all sounds");
                        return [4 /*yield*/, exports.api._fetch('/api/stop_sounds', 'POST', { guildId: guildId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    listUserFavorites: function () {
        return __awaiter(this, void 0, void 0, function () {
            var favorites;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Fetch favorite sounds");
                        return [4 /*yield*/, exports.api._fetch('/api/user_favorite')];
                    case 1:
                        favorites = (_a.sent()).favorites;
                        return [2 /*return*/, favorites];
                }
            });
        });
    },
    addUserFavorite: function (sound) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Add favorite sound ".concat(sound.name, " (").concat(sound.id, ")"));
                        return [4 /*yield*/, exports.api._fetch('/api/user_favorite', 'POST', { soundId: sound.id })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    deleteUserFavorite: function (sound) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Delete favorite sound ".concat(sound.name, " (").concat(sound.id, ")"));
                        return [4 /*yield*/, exports.api._fetch('/api/user_favorite', 'DELETE', { soundId: sound.id })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    listUserKeybinds: function () {
        return __awaiter(this, void 0, void 0, function () {
            var keybinds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Fetch keybinds");
                        return [4 /*yield*/, exports.api._fetch('/api/user_keybind')];
                    case 1:
                        keybinds = (_a.sent()).keybinds;
                        return [2 /*return*/, keybinds];
                }
            });
        });
    },
    addUserKeybind: function (sound, key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Save keybind ".concat(key, " for ").concat(sound.name, " (").concat(sound.id, ")"));
                        return [4 /*yield*/, exports.api._fetch('/api/user_keybind', 'POST', { soundId: sound.id, key: key })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    deleteUserKeybindForSound: function (sound) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Delete keybind for sound ".concat(sound.name, " (").concat(sound.id, ")"));
                        return [4 /*yield*/, exports.api._fetch('/api/user_keybind', 'DELETE', { soundId: sound.id })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    deleteUserKeybindForKey: function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, utils_1.log)("Delete keybind for key ".concat(key));
                        return [4 /*yield*/, exports.api._fetch('/api/user_keybind', 'DELETE', { key: key })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
};
